import React, { useEffect, useState } from 'react';
import logo from '../../../Images/logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginData } from '../../../Utils/loginSlice';
import { toogleReload } from '../../../Utils/reloadSlice';
import { toogleDailyQuotes } from '../../../Utils/dailyQuotesSlice';

const DailyQoutes = ({setEditDailyQuote}) => {
  const [loading, setLoading] = useState(false);
  const [dailyQuote, setDailyQuote] = useState([]);
  const [visible, setVisible] = useState(false);
  const isReload = useSelector((store) => store.reload.isReload);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSignOut = () => {
    dispatch(loginData("notexist"));
    navigate('/');
  }

  useEffect(() => {
    getData();
  }, [isReload]);

  const getData = async () => {
    const fetchData = await fetch('https://app-api.mokx.org/api/v1/daily_quotes');
    const json = await fetchData.json();
    setDailyQuote(json.data.dailyQuotess[0]);
  }

  const handleEdit = async () => {
    setLoading(true);
    const getData = await fetch(`https://app-api.mokx.org/api/v1/daily_quotes`);
    const json = await getData.json();
    setEditDailyQuote(json.data.dailyQuotess[0]);
    setTimeout(() => {
      dispatch(toogleDailyQuotes());
    }, 500)
    setLoading(false);
  }

  return (
    <>
      <div className="w-full h-screen">
        <div className="w-full py-5 flex flex-col gap-7">
          <div className="flex justify-between">
            <h1 className="text-[#000] text-2xl font-montserrat font-bold">
              Daily Quotes
            </h1>
            <div className='flex gap-5'>
              <div className='bg-clip flex justify-between items-center gap-3 rounded-[20px] px-3 text-[#FFF] cursor-pointer select-none' onClick={() => dispatch(toogleReload())}>
                Reload
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 512">
                  <path fill="white" d="M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208s208-93.31 208-208S370.69 48 256 48Zm120 182.15a8.62 8.62 0 0 1-8.62 8.62h-59.54a8.61 8.61 0 0 1-6.09-14.71l22.17-22.17l-5.6-6.51a87.38 87.38 0 1 0-62.94 148a87.55 87.55 0 0 0 82.42-58.25A16 16 0 1 1 368 295.8a119.4 119.4 0 1 1-112.62-159.18a118.34 118.34 0 0 1 86.36 36.95l.56.62l4.31 5l14.68-14.68a8.44 8.44 0 0 1 6-2.54a8.61 8.61 0 0 1 8.68 8.63Z"/>
                </svg>
              </div>
              <div className="w-[40px] h-[40px] pt-[3PX] bg-[#C4C4C4] rounded-full overflow-hidden cursor-pointer" onClick={() => handleSignOut()}>
                <img className='scale-110' src={logo} alt="usericon" />
              </div>
            </div>
          </div>
          <div className="flex flex-wrap gap-9">
            <div className="relative lg:w-[48%] md:w-[48%] w-[100%] bg-[#FFF] rounded-xl drop-shadow-3Xl py-7 pr-9 pl-4 mb-4 flex items-center gap-4" onMouseLeave={() => setVisible(false)}>
              <button className='w-[30px] h-[30px] flex-shrink-0' onMouseEnter={() => setVisible(true)}>
                <img className='w-[30px] h-[30px]' src={dailyQuote.dailyQoutesImage} alt="" />
              </button>
              <div>
                <h1 className='text-[#000] text-2xl font-figtree font-semibold'>{dailyQuote.dailyQoutesEnglish}</h1>
                <div className='text-[#000] text-xl font-figtree font-medium'>{dailyQuote.dailyQoutesHindi}</div>
              </div>
              {dailyQuote.length !== 0 && <div className='absolute right-1 top-1 cursor-pointer flex gap-1'>
                <button disabled={loading} onClick={() => handleEdit()}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                    <path fill={loading? "#86B0F4":"#286de0"} d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2m3.1 5.07c.14 0 .28.05.4.16l1.27 1.27c.23.22.23.57 0 .78l-1 1l-2.05-2.05l1-1c.1-.11.24-.16.38-.16m-1.97 1.74l2.06 2.06l-6.06 6.06H7.07v-2.06l6.06-6.06Z"/>
                  </svg>
                </button>
              </div>}
              {visible && <>
                <div className='w-full h-full fixed z-20 top-2.5 left-0 right-0 flex justify-center'>
                  <img className='w-60 h-60' src={dailyQuote?.dailyQoutesImage} alt='' />
                </div>
                <div className='w-full h-full z-10 fixed top-0 left-0 right-0 bottom-0 rounded-xl bg-[#282c3f]/[0.5]' />
              </>}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DailyQoutes;